import script from "./service-health-item.vue?vue&type=script&setup=true&lang=js"
export * from "./service-health-item.vue?vue&type=script&setup=true&lang=js"

import "./service-health-item.vue?vue&type=style&index=0&id=22e358dd&scoped=true&lang=scss"

import exportComponent from "D:\\vsts-agent\\_work\\53\\s\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-22e358dd"]])

export default __exports__